(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shade-fan-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const components = document.querySelectorAll('[data-shade-fan]');

    components.forEach((component) => {
      if (component.dataset.shadeFanReady === 'true') {
        return;
      }

      component.dataset.shadeFanReady = 'true';

      let fanData;
      let fallbackGroups;

      try {
        fanData = JSON.parse(component.dataset.fanData || 'null');
        fallbackGroups = JSON.parse(component.dataset.groups || '[]');
      } catch (error) {
        console.error('Shade fan JSON is invalid.', error);
        return;
      }

      const normalizeGroups = (groupList) => {
        if (!Array.isArray(groupList)) {
          return [];
        }

        return groupList
          .map((group, index) => {
            const swatches = Array.isArray(group.swatches) ? group.swatches : [];

            return {
              title: group.title || `Group ${index + 1}`,
              swatches: swatches.filter((swatch) => (swatch.code || swatch.label || '').toString().trim() !== '')
            };
          })
          .filter((group) => group.swatches.length > 0);
      };

      const normalizedFans = [];

      if (fanData && Array.isArray(fanData.fans)) {
        fanData.fans.forEach((fan, index) => {
          const groups = normalizeGroups(fan.groups);

          if (groups.length > 0) {
            normalizedFans.push({
              title: fan.title || `Fan ${index + 1}`,
              groups
            });
          }
        });
      } else {
        const singleFanGroups = normalizeGroups((fanData && fanData.groups) || fallbackGroups);

        if (singleFanGroups.length > 0) {
          normalizedFans.push({
            title: (fanData && fanData.title) || 'Shade fan',
            groups: singleFanGroups
          });
        }
      }

      if (normalizedFans.length === 0) {
        return;
      }

      const configuredSelector = component.dataset.targetFormSelector || '';
      const pickerInstanceId = component.id || `shade-fan-${Date.now()}`;
      const candidateForms = (() => {
        const forms = [];

        if (configuredSelector) {
          document.querySelectorAll(configuredSelector).forEach((node) => {
            if (node.matches && node.matches('form')) {
              forms.push(node);
              return;
            }

            const nestedForm = node.querySelector ? node.querySelector('form[action*="/cart/add"]') : null;

            if (nestedForm) {
              forms.push(nestedForm);
            }
          });
        }

        const closestForm = component.closest('form[action*="/cart/add"]');

        if (closestForm) {
          forms.push(closestForm);
        }

        document.querySelectorAll('form[action*="/cart/add"]').forEach((formNode) => {
          forms.push(formNode);
        });

        return Array.from(new Set(forms));
      })();
      const searchEmptyLabel = component.dataset.searchEmptyLabel || 'No results';
      const searchCountTemplate = component.dataset.searchCountTemplate || 'Found __COUNT__ shades';

      const drawer = component.querySelector('[data-drawer]');

      if (!drawer) {
        return;
      }

      // Keep modal outside the section node so Shopify editor overlays stay on the section only.
      if (!drawer.dataset.movedToBody) {
        document.body.appendChild(drawer);
        drawer.dataset.movedToBody = 'true';
      }

      const fanTabs = drawer.querySelector('[data-fan-tabs]');
      const groupTabs = drawer.querySelector('[data-group-tabs]');
      const swatchGrid = drawer.querySelector('[data-swatch-grid]');
      const searchInput = drawer.querySelector('[data-search-input]');
      const resultsCount = drawer.querySelector('[data-results-count]');
      const resultsList = drawer.querySelector('[data-results-list]');
      const activeGroupTitle = drawer.querySelector('[data-active-group-title]');
      const pendingSelection = drawer.querySelector('[data-pending-selection]');
      const selectionText = component.querySelector('[data-selection-text]');
      const selectionValue = component.querySelector('[data-selection-value]');
      const selectionError = component.querySelector('[data-selection-error]');
      const codeInput = component.querySelector('[data-shade-code-input]');
      const labelInput = component.querySelector('[data-shade-label-input]');
      const applyButton = drawer.querySelector('[data-apply-selection]');
      const summary = component.querySelector('[data-shade-summary]');

      if (!fanTabs || !groupTabs || !swatchGrid || !searchInput || !resultsCount || !resultsList || !activeGroupTitle || !pendingSelection || !applyButton || !summary) {
        return;
      }

      const getOrCreateMirrorInput = (form, role, sourceInput) => {
        if (form.contains(sourceInput)) {
          return sourceInput;
        }

        const selector = role === 'code'
          ? `input[data-shade-code-mirror="${pickerInstanceId}"]`
          : `input[data-shade-label-mirror="${pickerInstanceId}"]`;
        let mirror = form.querySelector(selector);

        if (!mirror) {
          mirror = document.createElement('input');
          mirror.type = 'hidden';
          mirror.name = sourceInput.name;

          if (role === 'code') {
            mirror.setAttribute('data-shade-code-mirror', pickerInstanceId);
          } else {
            mirror.setAttribute('data-shade-label-mirror', pickerInstanceId);
          }

          form.appendChild(mirror);
        }

        return mirror;
      };

      const syncSelectionToForms = () => {
        candidateForms.forEach((form) => {
          const codeMirror = getOrCreateMirrorInput(form, 'code', codeInput);
          const labelMirror = getOrCreateMirrorInput(form, 'label', labelInput);
          codeMirror.value = codeInput.value;
          labelMirror.value = labelInput.value;
        });
      };

      // Summary stays where the merchant places the section in Theme Editor.

      let activeFanIndex = 0;
      let activeGroupIndex = 0;
      let draftSelection = null;
      let query = '';

      const getCurrentFan = () => normalizedFans[activeFanIndex];

      const formatSelection = (selection) => `${selection.label || selection.code} (${selection.code})`;

      const findMatches = (value) => {
        const needle = value.trim().toLowerCase();

        if (!needle) {
          return [];
        }

        const found = [];
        const currentFan = getCurrentFan();

        currentFan.groups.forEach((group, groupIndex) => {
          const swatches = Array.isArray(group.swatches) ? group.swatches : [];

          swatches.forEach((swatch) => {
            const code = (swatch.code || '').toString().toLowerCase();
            const label = (swatch.label || '').toString().toLowerCase();

            if (code.includes(needle) || label.includes(needle)) {
              found.push({
                ...swatch,
                groupIndex,
                groupTitle: group.title
              });
            }
          });
        });

        return found;
      };

      const clearSelection = () => {
        codeInput.value = '';
        labelInput.value = '';
        draftSelection = null;
        syncSelectionToForms();
        selectionText.hidden = true;
        selectionValue.textContent = '';
        applyButton.disabled = true;
        pendingSelection.textContent = pendingSelection.dataset.emptyLabel || '';
        renderSwatches();
      };

      const closeDrawer = () => {
        drawer.hidden = true;
        document.body.classList.remove('shade-fan-open');
        if (query) {
          query = '';
          searchInput.value = '';
          renderSwatches();
          renderSearchResults();
        }
      };

      const openDrawer = () => {
        drawer.hidden = false;
        selectionError.hidden = true;
        document.body.classList.add('shade-fan-open');
      };

      const updateCommittedSelection = (selection) => {
        codeInput.value = selection.code;
        labelInput.value = selection.label || selection.code;
        syncSelectionToForms();
        selectionValue.textContent = formatSelection(selection);
        selectionText.hidden = false;
        pendingSelection.textContent = formatSelection(selection);
      };

      const updateDraftSelection = (selection) => {
        draftSelection = selection;
        pendingSelection.textContent = formatSelection(selection);
        applyButton.disabled = false;

        swatchGrid.querySelectorAll('[data-swatch-button]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.code === selection.code);
        });

        resultsList.querySelectorAll('[data-result-button]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.code === selection.code);
        });
      };

      const commitSelectionAndClose = (selection) => {
        updateDraftSelection(selection);
        updateCommittedSelection(selection);
        closeDrawer();
      };

      const renderFans = () => {
        fanTabs.innerHTML = '';

        if (normalizedFans.length < 2) {
          fanTabs.hidden = true;
          return;
        }

        fanTabs.hidden = false;

        normalizedFans.forEach((fan, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'shade-fan__fan-tab';
          button.textContent = fan.title;
          button.classList.toggle('is-active', index === activeFanIndex);
          button.addEventListener('click', () => {
            if (activeFanIndex === index) {
              return;
            }

            activeFanIndex = index;
            activeGroupIndex = 0;
            query = '';
            searchInput.value = '';
            renderFans();
            renderGroups();
            renderSwatches();
            renderSearchResults();
          });
          fanTabs.appendChild(button);
        });
      };

      const renderGroups = () => {
        groupTabs.innerHTML = '';
        const currentFan = getCurrentFan();

        currentFan.groups.forEach((group, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'shade-fan__group-tab';
          button.classList.toggle('is-active', index === activeGroupIndex);

          const preview = document.createElement('span');
          preview.className = 'shade-fan__group-preview';

          const firstSwatch = group.swatches[0];

          if (firstSwatch.image) {
            preview.style.backgroundImage = `url(${firstSwatch.image})`;
          } else if (firstSwatch.color) {
            preview.style.background = firstSwatch.color;
          }

          const label = document.createElement('span');
          label.className = 'shade-fan__group-label';
          label.textContent = group.title;

          button.append(preview, label);
          button.addEventListener('click', () => {
            activeGroupIndex = index;
            renderGroups();
            renderSwatches();
          });

          groupTabs.appendChild(button);
        });
      };

      const renderSwatches = () => {
        swatchGrid.innerHTML = '';
        const currentFan = getCurrentFan();

        let filteredSwatches;

        if (query.trim()) {
          const needle = query.trim().toLowerCase();
          filteredSwatches = [];
          currentFan.groups.forEach((group) => {
            group.swatches.forEach((swatch) => {
              const code = (swatch.code || '').toString().toLowerCase();
              const label = (swatch.label || '').toString().toLowerCase();
              if (code.includes(needle) || label.includes(needle)) {
                filteredSwatches.push(swatch);
              }
            });
          });
          activeGroupTitle.textContent = '';
        } else {
          const currentGroup = currentFan.groups[activeGroupIndex];
          activeGroupTitle.textContent = currentGroup.title;
          filteredSwatches = currentGroup.swatches;
        }

        filteredSwatches.forEach((swatch) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'shade-fan__swatch';
          button.dataset.swatchButton = 'true';
          button.dataset.code = swatch.code || '';
          button.classList.toggle('is-active', draftSelection && draftSelection.code === swatch.code);

          const preview = document.createElement('span');
          preview.className = 'shade-fan__swatch-preview';

          if (swatch.image) {
            preview.style.backgroundImage = `url(${swatch.image})`;
          } else if (swatch.color) {
            preview.style.background = swatch.color;
          }

          const code = document.createElement('span');
          code.className = 'shade-fan__swatch-code';
          code.textContent = swatch.code || '';

          const label = document.createElement('span');
          label.className = 'shade-fan__swatch-label';
          label.textContent = swatch.label || swatch.code || '';

          button.append(preview, code, label);
          button.addEventListener('click', () => updateDraftSelection(swatch));
          button.addEventListener('dblclick', () => commitSelectionAndClose(swatch));
          swatchGrid.appendChild(button);
        });
      };

      const renderSearchResults = () => {
        resultsList.innerHTML = '';

        if (!query.trim()) {
          resultsCount.textContent = pendingSelection.textContent;
          return;
        }

        const matches = findMatches(query);
        const limitedMatches = matches.slice(0, 12);

        if (matches.length === 0) {
          resultsCount.textContent = searchEmptyLabel;
          return;
        }

        resultsCount.textContent = searchCountTemplate.replace('__COUNT__', String(matches.length));

        limitedMatches.forEach((match) => {
          const item = document.createElement('li');
          item.className = 'shade-fan__result-item';

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'shade-fan__result-button';
          button.dataset.resultButton = 'true';
          button.dataset.code = match.code || '';
          button.textContent = `${match.groupTitle} - ${match.label || match.code}`;
          button.classList.toggle('is-active', draftSelection && draftSelection.code === match.code);

          button.addEventListener('click', () => {
            activeGroupIndex = match.groupIndex;
            renderGroups();
            renderSwatches();
            commitSelectionAndClose(match);
          });

          item.appendChild(button);
          resultsList.appendChild(item);
        });
      };

      component.addEventListener('click', (event) => {
        if (event.target.closest('[data-clear-selection]')) {
          event.stopPropagation();
          clearSelection();
        }
      });

      component.querySelector('[data-open-drawer]').addEventListener('click', openDrawer);

      drawer.querySelectorAll('[data-close-drawer]').forEach((element) => {
        element.addEventListener('click', closeDrawer);
      });

      searchInput.addEventListener('input', () => {
        query = searchInput.value || '';
        renderSwatches();
        renderSearchResults();
      });

      applyButton.addEventListener('click', () => {
        if (!draftSelection) {
          return;
        }

        commitSelectionAndClose(draftSelection);
      });

      candidateForms.forEach((form) => {
        form.addEventListener('submit', () => {
          syncSelectionToForms();
        });
      });

      syncSelectionToForms();

      renderGroups();
      renderFans();
      renderSwatches();
      renderSearchResults();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
